var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasErrors)?_c('div',{staticClass:"alert-error sticky inline",attrs:{"id":_vm.id,"role":"alert"}},_vm._l((_vm.validationErrors),function(error){return _c('div',{key:error},[_vm._v("\n    "+_vm._s(_vm.stripTags(error))+"\n  ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }